import * as S from './styles';
import WdLogo from '../../../WDLogo';


function BottomBarLogo() {
  return (
    <S.Container>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <WdLogo size='40px' />
      </div>
    </S.Container>
  );
}

export default BottomBarLogo;